// extracted by mini-css-extract-plugin
export default {"buyButton":"IM7oO","hasInCart":"OaQjd","iconCheck":"e5oWI"};